import { Tooltip } from '@material-ui/core';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import logo from './assets/logo.png';
import { clientVersion } from './main/clientVersion_tmp';
import { transl } from './main/transl';
import { windowSvc } from './services/WindowSvc';
import { getOmnistore } from './stores/Omnistore';

@observer export class LogoIcon extends React.Component<{className: string | undefined}> {
	@computed get authStore() {
		return getOmnistore().authStore;
	}

	@computed get reoctoStore() {
		return getOmnistore().reoctoStore;
	}

	@observable _queue: Array<number> = []

	@action _onClick = () => {
		const now = windowSvc.currentTimeMillis();
		const min = now - 15000;
		while (this._queue.length && this._queue[0]<min) this._queue.shift();
		this._queue.push(now);
		if (this._queue.length >= 7) this.reoctoStore.setAllowTesterDialog(true);
		if (this.reoctoStore.allowTesterDialog) this.reoctoStore.setShowTesterDialog(true);
	}

	@computed get _style() {
		if (this.reoctoStore.isOffline) return {};
		switch (this.authStore.role) {
		case 'ADMIN': return {transform: 'rotate(180deg)'};
		case 'HARMONIZER':
		case 'STANDARD': return {};
		}
	}

	render() {
		const {className} = this.props;
		return <Tooltip title={transl('nameOfReocto', clientVersion.replace(/-.*/, ''))}><img
			className={className}
			src={logo}
			alt="logo"
			style={this._style}
			onClick={this._onClick}
		/></Tooltip>;
	}
}
